import { useSelector } from "react-redux";
import SC from "./style";
import ct from "countries-and-timezones";
import InnoIcons from "@InnoIcons/";
import theme from "@theme/";

const GeneralInformation = () => {
  const currentProject = useSelector(
    (state) => state?.currentProject?.data || []
  );

  const country = ct.getCountry(`${currentProject?.countryName}`);
  const countryName = country?.name || "N/A";

  // Group information into logical categories
  const iconStyle = {
    fontSize: "24px",
    color: theme.colors.themeColor,
  };

  // Group information into logical categories
  const propertyGroups = [
    {
      title: "Property Details",
      items: [
        {
          label: "Property Name",
          value: currentProject.propertyName || "N/A",
          icon: <InnoIcons.AccountBalanceIcon style={iconStyle} />,
        },
        {
          label: "Property Address",
          value: currentProject?.address || "N/A",
          icon: <InnoIcons.LocationOnIcon style={iconStyle} />,
        },
        {
          label: "Property Size",
          value: `${currentProject?.occupantArea || 0} ${currentProject?.unit}`,
          icon: <InnoIcons.SquareFootIcon style={iconStyle} />,
        },
        {
          label: "Property Reference Number",
          value: currentProject?.referenceNo || "N/A",
          icon: <InnoIcons.TagIcon style={iconStyle} />,
        },
      ],
    },
    {
      title: "Contact Information",
      items: [
        {
          label: "Property Contact",
          value: currentProject?.propertyContact || "N/A",
          icon: <InnoIcons.PersonRoundedIcon style={iconStyle} />,
        },
        {
          label: "Contact No.",
          value: `${currentProject?.cellCode} ${
            currentProject?.contactNo || "N/A"
          }`,
          icon: <InnoIcons.PhoneIcon style={iconStyle} />,
        },
        {
          label: "Email",
          value: currentProject?.email || "N/A",
          icon: <InnoIcons.EmailIcon style={iconStyle} />,
        },
      ],
    },
    {
      title: "Project Information",
      items: [
        {
          label: "Opening Date",
          value: currentProject?.openingDate || "N/A",
          icon: <InnoIcons.CalendarMonthIcon style={iconStyle} />,
        },
        {
          label: "Total Occupants",
          value: currentProject?.totalOccupants || "N/A",
          icon: <InnoIcons.PersonAddIcon style={iconStyle} />,
        },
        {
          label: "Country Name",
          value: countryName || "N/A",
          icon: <InnoIcons.LanguageRoundedIcon style={iconStyle} />,
        },
        {
          label: "Time Zone",
          value: currentProject?.timeZone || "N/A",
          icon: <InnoIcons.ClockCircleOutlined style={iconStyle} />,
        },
      ],
    },
  ];

  return (
    <SC.PropertyDetailsContainer>
      <SC.PropertyInfo>
        <SC.InfoGrid>
          {propertyGroups.map((group, groupIndex) => (
            <SC.GroupCard key={groupIndex}>
              <SC.GroupHeader>
                <SC.GroupTitle>{group.title}</SC.GroupTitle>
              </SC.GroupHeader>
              <SC.GroupContent>
                {group.items.map((info, index) => (
                  <SC.InfoRow key={index}>
                    <SC.InfoLabel>
                      <span style={{ marginRight: "8px" }}>{info.icon}</span>
                      {info.label}
                    </SC.InfoLabel>
                    <SC.InfoValue>{info.value}</SC.InfoValue>
                  </SC.InfoRow>
                ))}
              </SC.GroupContent>
            </SC.GroupCard>
          ))}
        </SC.InfoGrid>
      </SC.PropertyInfo>
    </SC.PropertyDetailsContainer>
  );
};

export default GeneralInformation;
